import React from "react";
import { Link } from "react-router-dom";
import { Container, Row, Col, Button } from "react-bootstrap";

const NotFound = () => {
  return (
    <section className="notfound_page d-flex align-items-center vh-100">
      <Container>
        <Row className="justify-content-center text-center">
          <Col md={8}>
            <div className="notfound-card p-5 rounded-4 shadow-lg bg-dark text-white">
              <h1 className="display-1 fw-bold text-gradient mb-3">404</h1>
              <h2 className="mb-3">Oops! Page Not Found</h2>
              <p className="mb-4 text-light">
                The page you are looking for might have been removed,
                had its name changed, or is temporarily unavailable.
              </p>
              <Link to="/">
                <Button size="lg" className="btn-gradient">
                  Back to Home
                </Button>
              </Link>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default NotFound;
